import { Provider } from '@qnpm/qportal';
import { PopupLayer } from './PopupLayer';
import { QPopupLayer } from './QPopupLayer';
export { PopupLayer, QPopupLayer, Provider as QPopupLayerProvider };
export default PopupLayer;
